module.exports = __webpack_public_path__ + "static/media/form.85409b39.svg";